import React from "react";
import { AdicionarStageContainer } from "./styles";
import Modal from "../../../../../../shared/util/Modal";
import DefaultButton from "../../../../../../shared/util/DefaultButton";
import AddStageForm from "./components/addStageForm";

function AddStage({
	open,
	setOpen,
	requireStageList,
}: Readonly<{
	open: boolean;
	setOpen: React.Dispatch<boolean>;
	requireStageList(): Promise<void>;
}>) {
	const [loading, setLoading] = React.useState(false);
	const [successMessage, setSuccessMessage] = React.useState("");

	React.useEffect(() => {
		if (!open) {
			setSuccessMessage("");
		}
	}, [open]);

	return (
		<AdicionarStageContainer>
			<Modal
				open={open}
				setOpen={setOpen}
				containerClassName="adicionar-stage-modal-container"
				title={!successMessage ? <h2>Criar Fase da Ideia</h2> : <></>}
				closeButtonCb={!successMessage ? () => setOpen(false) : undefined}
				disableClickOutside={true}
			>
				{!successMessage && (
					<AddStageForm
						setOpen={setOpen}
						isLoading={loading}
						setLoading={setLoading}
						setSuccessMessage={setSuccessMessage}
						requireStageList={requireStageList}
					/>
				)}

				{successMessage && (
					<div className="edit-stage-success-step">
						<h2>{successMessage}</h2>
						<div>
							<DefaultButton
								withOutBackground={true}
								width="125px"
								fontSize="1em"
								height="36px"
								params={{
									onClick: () => setOpen(false),
								}}
							>
								Fechar
							</DefaultButton>
						</div>
					</div>
				)}
			</Modal>
		</AdicionarStageContainer>
	);
}

export default AddStage;
